export type TachyonsScaleInput = string | number | undefined;
interface ResponsiveInput<T> {
	mobile: T;
	desktop: T;
}

//eslint-disable-next-line @typescript-eslint/no-explicit-any
const isResponsiveInput = <T>(value: any): value is ResponsiveInput<T> =>
	value && value.mobile != null && value.desktop != null;

/** Takes a parser of units, and returns a parser that accepts either a
 * value or a responsive input of that same type of value
 * (i.e. {mobile: ..., desktop: ...}), and returns an object of the same
 * format of the input.
 */
export const parseResponsive =
	<T, U>(parse: (value: T) => U) =>
	(value: T | ResponsiveInput<T>): null | U | { mobile: U; desktop: U } => {
		if (isResponsiveInput(value)) {
			return {
				mobile: parse(value.mobile),
				desktop: parse(value.desktop),
			};
		}

		return parse(value);
	};

const parseDimension = (input: string): null | number | string => {
	if (typeof input !== 'string') {
		return null;
	}

	if (input === 'grow') {
		return 'grow';
	}

	const supportedUnits = ['%'];
	const match = input.match(new RegExp(`(\\d*)(${supportedUnits.join('|')})`));

	if (!match) {
		return null;
	}

	const value = match[1];
	// TODO: support multiple units
	// const unit = match[2]

	if (value == null) {
		return null;
	}

	const parsedValue = parseInt(value, 10);

	return parsedValue;
};

export const parseWidth = parseResponsive(parseDimension);

export const parseHeight = parseDimension;
